
import Vuex from "vuex";
import Vue from "vue";
import { LOCAL_STORAGE } from "../utils/localStorage";

Vue.use(Vuex);

const state = {
  user: LOCAL_STORAGE.GET({ key: "auth"}),
};

//modifier le state (setters)
const mutations = {
    setUser: (state, user) => state.user = user,
    //logoutUser:(state) => state.user = null
};
// appelle les mutation pour modifier le state
const actions = {
  setUser({ commit }, user) {
    commit("setUser", user);
  },
  logoutUser({ commit }) {
    commit("setUser", null);
  },
};

const getters = {
    isAuthenticated: (state) => state.user !== null,
    user: (state) => state.user
};



export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
});

